<mode-tree-view
  [nodes]="fields"
  [template]="fieldTemplate"
  [getId]="getId"
  [getChildren]="getChildren"
  [selectedId]="selectedId"
  [showSearch]="showSearch"
  (selectedIdChange)="selectedIdChange.emit($event)"
></mode-tree-view>

<ng-template #fieldTemplate
  let-node
>
  <capra-icon *ngIf="fieldIcons[node.id]?.name"
    class="field-icon field-icon--{{ fieldIcons[node.id]?.type }}"
    [icon]="fieldIcons[node.id]?.name"
  ></capra-icon>
  <p class="name">
    {{ node.name }}
  </p>
</ng-template>
